
import Modify from 'ol/interaction/Modify';

import { calculateMeasureValuesInGeometry } from './measureValues';

function createInteractionMeasureModify(options) {

    let modify = new Modify({
        source: options.measureLayer.getSource()
    });

    modify.set('mapToolId', 'MeasureModify');
    modify.setActive(false);

    modify.on('modifyend', (e) => {
        if (options.onMapToolExecute) {
            if (e.features.getLength() > 0) {
                const feature = e.features.item(0);
                calculateMeasureValuesInGeometry(feature.getGeometry());

                options.onMapToolExecute(
                    modify.get('mapToolId'),
                    {
                        feature: feature,
                        values: feature.getGeometry().get('values')
                    }
                );
            }
        }
    });

    return modify;
}

export default createInteractionMeasureModify;
